export class ContentTypesActionsService<T> {
	handlers: Set<(data: T) => void> = new Set();

	dispose(): void {
		this.handlers.clear();
	}

	updateActions(data: T): void {
		this.handlers.forEach((handler) => handler(data));
	}

	onActionsUpdate(cb: (data: T) => void) {
		this.handlers.add(cb);

		return (): void => {
			this.handlers.delete(cb);
		};
	}
}
